import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import {
  OAuthService,
  JwksValidationHandler,
  OAuthErrorEvent,
} from "angular-oauth2-oidc";
import { Router, NavigationEnd } from "@angular/router";
import * as jwt_decode from "jwt-decode";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { AuthConfiguration } from "./core/auth.configuration";
import { environment } from "../environments/environment";
import { slideInAnimation } from "./route-animation";
import { AuthProdConfiguration } from "./core/auth.prod.configuration";
import Quill from "quill";
import { NotificationService } from "./services/notification.service";
import { A } from "@angular/cdk/keycodes";
import { Location } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute } from "@angular/router";
import { NRInitializationService } from "./services/newrelic-initialization.service";
import { NRAuthInitializationService } from "./services/auth-init.service";
import { AuthDevConfiguration } from "./core/auth.dev.configuration";
import { CryptographyService } from "./services/cryptography.service";
import { UserRoleEnum } from "./core/constant";
// const parchment = Quill.import("parchment");
// const block = parchment.query("block");
// block.tagName = "DIV";
// or class NewBlock extends Block {} NewBlock.tagName = 'DIV'
// Quill.register(block /* or NewBlock */, true);
declare var newrelic: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: [slideInAnimation],
})
export class AppComponent implements OnInit {
  get token() {
    return this.oauthService.getAccessToken();
  }
  get claims() {
    return this.oauthService.getIdentityClaims();
  }

  title = "McD.GRBES.Web";
  http: HttpClient;
  activatedRoute: ActivatedRoute;

  constructor(
    private oauthService: OAuthService,
    private _router: Router,
    public notificationService: NotificationService,
    private location: Location,
    private nrInit: NRInitializationService,
    private nrAuthInit: NRAuthInitializationService,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private cryptographyService: CryptographyService,
  ) {
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
    if (window.location.href.includes("access_token")) {
      this.nrAuthInit.setTokenReceieved();
    }
    if (!this.nrInit.isInitialized()) {
      this._router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (typeof newrelic !== "undefined" && newrelic.setCurrentRouteName) {
            newrelic.addPageAction("PageView", {
              path: event.urlAfterRedirects,
            });
          }
        }
      });
      this.nrInit.setInitialized();
    }
    //   // alert(oauthService.hasValidAccessToken());
    //   // if (!oauthService.hasValidAccessToken()) oauthService.logOut();
    //   // if(_router.url=="")
    //   oauthService.events.subscribe((e) =>
    //     e instanceof OAuthErrorEvent ? console.error(e) : console.warn(e)
    //   );
    //   oauthService.configure(AuthProdConfiguration);
    //   // Load information from Auth0 (could also be configured manually)
    //   // this.oauthService.logOut();
    //   // //;
    //   oauthService
    //     .loadDiscoveryDocument()
    //     // See if the hash fragment contains tokens (when user got redirected back)
    //     .then(() => oauthService.tryLogin())
    //     // If we're still not logged in yet, try with a silent refresh:
    //     .then(() => {
    //       // alert(success);
    //       // alert(oauthService.hasValidAccessToken());
    //       if (!oauthService.hasValidAccessToken())
    //         oauthService.initImplicitFlow();
    //       // alert(oauthS)
    //     })
    //     // Get username, if possible.
    //     .then(() => {});
  }


  async sendAuthEvent(loginStatus, name, email, userRole, screenResolution) {
    this.http
      .post("/api/Analytics/RecordSearchEvent", [
        {
          eventType: "GRSAuthenticationPROD",
          status: loginStatus,
          name,
          email,
          userRole,
          screenResolution,
          session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
        },
      ])
      .subscribe({ next: () => void 0, error: () => void 0 });
  }
  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }

  ngOnInit() {
    const hasRefreshed = sessionStorage.getItem('app_refreshed');
  
  if (!hasRefreshed) {
    
    sessionStorage.setItem('app_refreshed', 'true');
   
    
    // Refresh the page
    window.location.reload();
    return; // Stop execution here
  }
    const userRoleId = this.cryptographyService.decryptData(
      this.storage.get("userRole"),
    );
    const userRoleType = UserRoleEnum[userRoleId];
    const screenResolution = `${window.screen.width}x${window.screen.height} pixels`;

    console.error = (a) => {};
    if (environment.skipAuthentication) {
      this._router.initialNavigation();
      this._router.navigateByUrl(this.location.path());
      return;
    }
    if (environment.useProdConfiguration) {
      this.oauthService.configure(AuthProdConfiguration);
    } else if (environment.useDevConfiguration) {
      // alert("true")
      this.oauthService.configure(AuthDevConfiguration);
    } else {
      this.oauthService.configure(AuthConfiguration);
    }

    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    // this.oauthService.initImplicitFlow();
    this.oauthService.tryLogin().then(async () => {
      if (!this.nrAuthInit.isInitialized()) {
        this.nrAuthInit.setInitialized();
        return;
      }
      let totalDelay = 0;

      const waitUntilStorageSet = async () => {
        while (!localStorage.getItem("NRBA_SESSION") && totalDelay < 5000) {
          // max wait 5s to avoid infinite loop
          await this.delay(100);
          totalDelay += 100;
        }
      };
      if (!this.oauthService.hasValidAccessToken()) {
        sessionStorage.setItem("redirectUrl", this.location.path());
        this.oauthService.initImplicitFlow();
        return;
      } else {
        
        await waitUntilStorageSet();

        const decodedToken = this.getDecodedAccessToken(
          this.oauthService.getAccessToken(),
        );
        const isLogged = JSON.parse(
          localStorage.getItem("isLoggedIn") || "false",
        );
   let email;
        if (environment.useDevConfiguration) {
  email = decodedToken?.preferred_username ;
} else if (environment.useProdConfiguration) {
  email = decodedToken?.email ;
}  else{
  email = decodedToken?.upn ;
}
        const tokenreved = this.nrAuthInit.isTokenReceieved();
        if (this.nrAuthInit.isTokenReceieved() && !isLogged) {
          if (userRoleType) {
             const [first = "", last = ""] = email?.split("@")[0]?.split(".") || [];

            const toCamelCase = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
            await this.sendAuthEvent(
              "LoginSuccess",
              email.includes("external") ? decodedToken.name : `${toCamelCase(first)} ${toCamelCase(last)}`.trim(),
              email,
              userRoleType,
              screenResolution,
            );
         
            localStorage.setItem("isLoggedIn", JSON.stringify(true));
          }
        }
      }

      const redirectUrl = localStorage.getItem("redirectUrl");
      this._router.initialNavigation();
      if (redirectUrl) {
        // alert("redirectUrl: " + redirectUrl);
        this._router.navigateByUrl(redirectUrl);
        localStorage.removeItem("redirectUrl");
      } else {
        const currentPath = this.location.path();
        // Navigate to locations if on root or empty path
        if (!currentPath || currentPath === '/' || currentPath === '') {
            this._router.navigateByUrl('/locations');
        } else {
            this._router.navigateByUrl(currentPath);
        }
      }
    });
  }

  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  // ngOnInit(): void {
  //   this._router.initialNavigation();
  //   this._router.navigateByUrl("/locations");
  // }
}
